"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OccasionCampaignLocalizedReferenceSchema = void 0;
exports.OccasionCampaignLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/occasion-campaigns.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "OccasionCampaignLocalizedReference",
    "description": "Campaign to motivate user groups to participate in mini games to get benefits like free cans or entry to an event",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:occasion-campaigns"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoib2NjYXNpb24tY2FtcGFpZ25zLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9tb2R1bGVzL3JlZmVyZW5jZS9sb2NhbGl6ZWQvY29udGVudC9vY2Nhc2lvbi1jYW1wYWlnbnMuc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsd0NBQXdDLEdBQUc7SUFDdEQsS0FBSyxFQUFFLDRGQUE0RjtJQUNuRyxTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSxvQ0FBb0M7SUFDN0MsYUFBYSxFQUFFLG1IQUFtSDtJQUNsSSxNQUFNLEVBQUUsUUFBUTtJQUNoQixVQUFVLEVBQUU7UUFDVixNQUFNO1FBQ04sSUFBSTtLQUNMO0lBQ0QsWUFBWSxFQUFFO1FBQ1osTUFBTSxFQUFFO1lBQ04sTUFBTSxFQUFFO2dCQUNOLGdDQUFnQzthQUNqQztZQUNELE1BQU0sRUFBRSxRQUFRO1NBQ2pCO1FBQ0QsSUFBSSxFQUFFO1lBQ0osTUFBTSxFQUFFLFFBQVE7WUFDaEIsU0FBUyxFQUFFLGlHQUFpRztTQUM3RztLQUNGO0NBQ0YsQ0FBQSJ9